{
  "INTEGRATION_APPS": {
    "FETCHING": "Fetching Integrations",
    "NO_HOOK_CONFIGURED": "There are no {integrationId} integrations configured in this account.",
    "HEADER": "Applications",
    "STATUS": {
      "ENABLED": "Enabled",
      "DISABLED": "Disabled"
    },
    "CONFIGURE": "Configure",
    "ADD_BUTTON": "Add a new hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirm deletion",
        "ACCOUNT": "Disconnect"
      },
      "MESSAGE": {
        "INBOX": "Are you sure to delete?",
        "ACCOUNT": "Are you sure to disconnect?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Yes, Delete",
        "ACCOUNT": "Yes, Disconnect"
      },
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "SUCCESS_MESSAGE": "Hook deleted successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "LIST": {
      "FETCHING": "Fetching integration hooks",
      "INBOX": "Inbox",
      "EDIT": {
        "BUTTON_TEXT": "Redakto"
      },
      "DELETE": {
        "BUTTON_TEXT": "Delete"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Select Inbox",
          "PLACEHOLDER": "Select Inbox"
        },
        "SUBMIT": "Create",
        "CANCEL": "Cancel"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integration hook added successfully",
        "ERROR_MESSAGE": "Could not connect to chat server, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Redakto {name}",
      "FORM": {
        "SUBMIT": "Përditëso",
        "CANCEL": "Anulo"
      },
      "API": {
        "SUCCESS_MESSAGE": "Lidhja e integrimit u përditësua me sukses",
        "ERROR_MESSAGE": "Lidhja me serverin e chat-it dështoi, provoni përsëri më vonë"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Connect"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Disconnect"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Sinkronizoni email-et dhe chat-et e faqes me llogarinë tuaj daktela.",
      "RETINO": "Retino sjell rregull në menaxhimin e kthimeve dhe ankesave.",
      "MAILSHIP": "Mailship është një sistem menaxhimi i depove dhe përmbushjes së porosive. Kontrolloni statusin e porosisë, gjurmimin dhe detajet e dërgesës.",
      "RAYNET": "Lidhni llogarinë tuaj Raynet CRM për të aksesuar të dhënat e klientëve. Shtoni një lidhje me emrin tuaj të përdoruesit dhe token-in API të Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Testo lidhjen",
      "SUCCESS": "Lidhja u krye me sukses",
      "ERROR": "Lidhja dështoi. Ju lutemi kontrolloni kredencialet tuaja."
    }
  }
}
